
const VALIDATE_SUCCESS = 'VALIDATE_SUCCESS'
const VALIDATE_FAIL = 'VALIDATE_FAIL'
const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
const RESET_PASSWORD_FAIL = 'RESET_PASSWORD_FAIL'
const SEND_EMAIL_SUCCESS = 'SEND_EMAIL_SUCCESS'
const SEND_EMAIL_FAIL = 'SEND_EMAIL_FAIL'

export const defaultPasswordresetState = {
  valid: null,
  complete: false,
}

export default (state = defaultPasswordresetState, action) => {
  switch (action.type) {
    case VALIDATE_SUCCESS:
      if (action.payload.data.success) {
        return {
          ...state,
          valid: true,
        }
      } else {
        return {
          ...state,
          valid: false
        }
      }
    case VALIDATE_FAIL:
      return {
        ...state,
      }
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
      }
    case RESET_PASSWORD_FAIL:
      return {
        ...state
      }
    case SEND_EMAIL_SUCCESS:
      if (action.payload.data.success) {
        return {
          ...state,
          complete: true,
        }
      } else {
        return {
          ...state,
          complete: false
        }
      }

    case SEND_EMAIL_FAIL:
      return {
        ...state,
        complete: false
      }
    default:
      return state
  }
}
